// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimeline-Footer_cls1__sgZRr","cls2":"VeloTimeline-Footer_cls2__M4udU VeloTimeline-Footer_cls1__sgZRr"};